import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { PostgradContractExtensionState } from './state';
import { CourseModel } from '@descomplica/dex-models';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import { getDiffTime } from '@/helpers/date';
import { ContractExtensionEligibilityInfo } from '@/models/contractExtension/ContractExtensionEligibilityModel';
import { DefaultContractExtensionTrackingProps } from '@/helpers/analytics/types';

const getters: GetterTree<PostgradContractExtensionState, RootState> = {
  contractExtensionEligibilityInformationByCourseId: (state) => (courseId: number) => {
    if (!courseId) return null;

    const eligibilityInformation = state.contractExtensionEligibilityByCourseId[courseId];

    return eligibilityInformation || null;
  },
  defaultContractExtensionTrackingProps: (
    state,
    storeGetters,
  ): DefaultContractExtensionTrackingProps => {
    const { currentCourse }: { currentCourse: CourseModel } = storeGetters;
    const expiredChimeraCourse: ChimeraCourseModel | null = storeGetters.expiredChimeraCourseById(
      currentCourse.descomplicaCourseId,
    );
    const extensionEligibilityDataForCourse: ContractExtensionEligibilityInfo | null =
      state.contractExtensionEligibilityByCourseId[currentCourse.id];

    const extensionOptionsPeriods =
      extensionEligibilityDataForCourse?.extensionOptions.map((o) => o.period) || [];

    const daysAfterContractExpiration = expiredChimeraCourse?.mostRecentExpiredCourseContract
      ? getDiffTime(new Date(), expiredChimeraCourse.mostRecentExpiredCourseContract.expirationDate)
          .days
      : null;

    const props = {
      can_extend_contract: extensionOptionsPeriods.length > 0,
      descomplica_course_id: currentCourse.descomplicaCourseId,
    };

    if (daysAfterContractExpiration && daysAfterContractExpiration > 0) {
      Object.assign(props, {
        days_after_contract_expiration: daysAfterContractExpiration,
      });
    }

    if (extensionEligibilityDataForCourse) {
      Object.assign(props, {
        available_extension_options: extensionOptionsPeriods,
        available_extension_options_quantity: extensionOptionsPeriods.length,
        contract_extension_testing_group: extensionEligibilityDataForCourse.group,
      });
    }

    return props as DefaultContractExtensionTrackingProps;
  },
};

export default getters;
